import { connect } from "react-redux";

import * as actions_misc from "../../../_actions/misc";
import MaintenanceNotice from "../components/MaintenanceNotice";

const mapStateToProps = ({ Misc }) => ({
    language: Misc.language.language,
    store: Misc.store.store,
    country: Misc.country.country,
    country_list: Misc.country.country_list
});

const mapDispatchToProps = dispatch => ({
    setLanguage: language => {
        dispatch(actions_misc.setLanguage(language));
    },
    setStore: store => {
        dispatch(actions_misc.setStore(store));
    },
    setCountry: country => {
        dispatch(actions_misc.setCountry(country));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceNotice);
